import {
  getValueInStorage,
  setValueInStorage,
} from "../hooks/localStorageHelpers";

// Remembers the most recent audit reason ("Permission" for Run SQL, "Justification" for file
// downloads) so it can be auto-populated, saving Octonauts from re-pasting the same incident
// reference repeatedly during an incident. The reason is still submitted and audited on every
// action; this only pre-fills the input. It expires after an hour so people don't fall into a
// habit of submitting stale, no-longer-relevant reasons.
const KEY = "cloudportal:remembered-justification";
const TTL_MS = 60 * 60 * 1000; // 1 hour

interface StoredJustification {
  value: string;
  expiresAt: number;
}

// Returns the remembered reason, or "" if absent/expired/unparseable.
export function getRememberedJustification(): string {
  const raw = getValueInStorage(KEY);
  if (!raw) return "";
  try {
    const parsed: StoredJustification = JSON.parse(raw);
    if (
      typeof parsed.value === "string" &&
      typeof parsed.expiresAt === "number" &&
      parsed.expiresAt > Date.now()
    )
      return parsed.value;
  } catch {
    // Unparseable entry - treat as if nothing was remembered.
  }
  return "";
}

// Persists a non-empty reason with a fresh 1-hour expiry. No-op for blank/missing values.
export function rememberJustification(value: string | undefined): void {
  if (!value?.trim()) return;
  setValueInStorage(
    KEY,
    JSON.stringify({
      value,
      expiresAt: Date.now() + TTL_MS,
    } satisfies StoredJustification),
  );
}
